<template>
   <div>

       <PageHeader :linkto="'/home'" :linkttitle="'返回'" title=""></PageHeader>
       <b-container v-if="show" class="bg-white px-2 px-md-5 pb-5 mb-5 shadow-sm rounded ">

           <div class="text-center pt-3">
               <h3>姓名DNA購買方案</h3>
               <p>選擇最適合您的購買方案</p>
           </div>

           <b-card-group deck v-if="shopcard.length > 0">
               <b-card v-for="(item , index) in shopcard" v-bind:key="index"

                       :title="item.product_detail.product_name"
                       :img-src="item.product_detail.cover"
                       img-alt="Image"
                       img-top
                       tag="article"
                       style="max-width: 18rem;"
                       class="mb-2 mx-lg-3 mx-auto shadow-lg"
               >
                   <b-card-text>
                       {{ item.product_detail.product_desc}}
                   </b-card-text>


                   <b-button  v-if="item.product_detail.plan_type==3" class="mt-3" variant="success" block @click="getGift(item)"><b-spinner small v-if="reloadgift"></b-spinner> 領取贈點</b-button>


                   <b-button v-if="item.product_detail.plan_type==2" href="#" variant="danger" block @click="checkOut(item,'credit')">成為業務會員</b-button>
               </b-card>

           </b-card-group>

           <hr v-if="UserPlan.promo.length > 0">
           <b-card-group deck v-if="UserPlan.promo.length > 0">
               <b-card v-for="(item , index) in UserPlan.promo" v-bind:key="index"
                       border-variant="warning"
                       header-bg-variant="warning"
                       header="會員獨享方案"
                       :title="item.product_name"
                       :img-src="item.cover"
                       img-alt="Image"
                       img-top
                       tag="article"
                       style="max-width: 18rem;"
                       class="mb-2 mx-lg-3 mx-auto shadow-lg text-center"
               >
                   <b-card-text>
                       {{ item.product_desc}}
                   </b-card-text>
                   <h5>${{item.price }} / {{changePointToString(item.get_point) }} 點</h5>
                   <b-button v-if="item.plan_type==3"  variant="warning" block @click="gotoPayOut(item,'credit')">立即購買</b-button>
                   <b-button v-if="item.plan_type==2" href="#" variant="danger" block @click="checkOut(item,'credit')">成為會員</b-button>

               </b-card>

           </b-card-group>

           <hr v-if="UserPlan.member.length > 0">
           <b-card-group deck v-if="UserPlan.member.length > 0">
               <b-card v-for="(item , index) in UserPlan.member" v-bind:key="index"

                       :title="item.product_name"
                       :img-src="item.cover"
                       img-alt="Image"
                       img-top
                       tag="article"
                       style="max-width: 18rem;"
                       class="mb-2 mx-lg-3 mx-auto shadow-lg text-center"
               >
                   <b-card-text>
                       {{ item.product_desc}}
                   </b-card-text>
                   <h5>${{item.price }} / {{changePointToString(item.get_point) }} 點</h5>
                   <b-button v-if="item.plan_type==3"  variant="warning" block @click="gotoPayOut(item,'credit')">立即購買</b-button>
                   <b-button v-if="item.plan_type==2" href="#" variant="danger" block @click="checkOut(item,'credit')">成為會員</b-button>

               </b-card>

           </b-card-group>

           <hr v-if="UserPlan.point.length > 0">
           <b-card-group deck v-if="UserPlan.point.length > 0">

               <b-card v-for="(item , index) in UserPlan.point" v-bind:key="index"

                       :title="item.product_name"
                       :img-src="item.cover"
                       img-alt="Image"
                       img-top
                       tag="article"
                       style="max-width: 18rem;"
                       class="mb-2 mx-lg-3 mx-auto shadow-lg text-center"
               >
                   <b-card-text>
                       {{ item.product_desc}}
                   </b-card-text>
                   <h5>${{item.price }} / {{ item.get_point }} 點</h5>
                   <b-button href="#" variant="success" block @click="gotoPayOut(item,'credit')">購買使用點數</b-button>
               </b-card>

           </b-card-group>

           <h4 class="text-center" v-if="UserPlan.promo.length ==0 && UserPlan.member.length ==0 && UserPlan.point.length==0">
               目前無方案提供
           </h4>

       </b-container>


   </div>
</template>

<script>
import {mapState} from 'vuex'
import PageHeader from '@/components/PageHeader.vue'
import { alertModel,toCurrency } from '@/service/commuse'

export default {
  name: 'User_ProductPlan',
  components: {PageHeader},
  computed: {
    ...mapState(['plan','profiledata']),
  },
  data () {
    return {
      payStatus:false,
      show:false,
      UserPlan:{
        point:[],
        member:[]
      },
      shopcard:{},
      reloadgift:false
    }
  },
  mounted () {
    // this.$store.dispatch('actionGetProductWebID', {
    //   type: 'web',
    // }).then((res) => {
    //   this.show=true
    // }).catch((res) => {})
    this.appStatus()
    this.getUserPlan()
    // this.getInvite()
  },
  methods: {
    checkOut(item,way){

      this.$store.dispatch('actionShopCart',item)
      let orderData = {
        puid:item.product_id,
        ChoicePay:way
      }
      this.$store.dispatch('actionOrderPurchase',orderData)
      this.$store.dispatch('actionPuidDo', {puid:orderData.puid}).then((res) => {

        switch (res.data.do){
          case "contract-lv2":
            this.$router.push('/Payment/Contract');
            break
          case "contract-lv3":
            this.$router.push('/Payment/AgentContract');
            break
        }

      }).catch((res) => {})
    },
    gotoPayOut(item,way){

      this.$store.dispatch('actionCheckOut', {Puid:item.product_id,ChoicePay:way}).then((res) => {

        document.open();
        document.write(res);
        document.close();

      }).catch((res) => {

      })

    },



    Currency(num){
      return toCurrency(num)
    },
    appStatus(){
      this.$store.dispatch('actionGetAppStatus',{})
        .then((res) => {
          this.payStatus = res.data.payment
        })
        .catch((res) => {})
    },
    getUserPlan(){
      this.$store.dispatch('actionProductNew',{})
        .then((res) => {
          this.UserPlan = res.data
          this.show = true
        })
        .catch((res) => {})
    },
    getInvite(){
      this.reload = true
      this.$store.dispatch('actionGetInvite', {})
        .then((res) => {
          this.reload = false
          this.show = true
          this.shopcard = res.data
        }).catch((res) => {
        this.reload = false
      })
    },
    getGift(item){

      this.$store.dispatch('actionPointGift', {
        id:item.id,
        suuid:item.suuid,
        puid:item.puid
      }).then((res) => {
        alertModel(this,"系統訊息",res.message)
        this.$store.dispatch('actionGetMemberInfo', {})
        this.getInvite()
      }).catch((res) => {
        alertModel(this,"系統訊息",res.message)

      })
    },
    changePointToString(point){

      return point==9999999?'無限制':point;

    }




  }
}
</script>

